import Select from "react-select";
import { Form } from "react-bootstrap";
import { useState, useEffect } from "react";
import { developAxios } from "../../../axios.config";
import { useQuery } from "react-query";
import { BASE_URL } from "../../../env";

const GetResults = () => {
	const [course, setCourse] = useState<{
		value: string;
		label: string;
	} | null>(null);
	const [company, setCompany] = useState<{
		value: string;
		label: string;
	} | null>(null);
	const [examType, setExamType] = useState<{
		value: string;
		label: string;
	} | null>(null);
	const [cardId, setCardId] = useState<{
		value: string;
		label: string;
	} | null>(null);
	const [examId, setExamId] = useState<{
		value: string;
		label: string;
	} | null>(null);
	const [courseOptions, setCourseOptions] = useState<
		Array<{
			value: string;
			label: string;
		}>
	>([]);
	const [companyOptions, setCompanyOptions] = useState<
		Array<{
			value: string;
			label: string;
		}>
	>([]);
	const [cardIdOptions, setCardIdOptions] = useState<
		Array<{
			value: string;
			label: string;
		}>
	>([]);
	const [examOptions, setExamOptions] = useState<
		Array<{
			value: string;
			label: string;
		}>
	>([]);
	const [fileName, setFileName] = useState("Results");

	useEffect(() => {
		developAxios(localStorage.getItem("token") || "")
			.get<{
				courses: Array<{
					_id: string;
					name: string;
				}>;
			}>("/getallCourse")
			.then(({ data }) => {
				let options = data.courses.map((course) => {
					return {
						value: course._id,
						label: course.name,
					};
				});

				setCourseOptions(options);
			});
	}, []);

	useQuery(
		["getProjectSpecification", course?.value],
		() =>
			developAxios(localStorage.getItem("token") || "").get<{
				data: Array<{
					_id: string;
					companyName: string;
				}>;
			}>("/ps/getProjectSpecification/" + course?.value),
		{
			enabled: course !== null,
			onSuccess: ({ data }) => {
				console.log(data);
				setCompanyOptions(
					data.data.map((company) => {
						return {
							value: company._id,
							label: company.companyName,
						};
					})
				);
			},
			onError: (err: any) => {
				if (err.response.status === 422) {
					alert("No project specification found for this course");
				}
			},
		}
	);

	useQuery(
		["getCards", company?.value],
		() =>
			developAxios(localStorage.getItem("token") || "").get<
				Array<{
					_id: string;
					mcq: Array<string>;
					name: string;
					coding: Array<string>;
				}>
			>("/ps/getAllCards/" + company?.value),
		{
			enabled: examType?.value === "pyq",
			onSuccess: ({ data }) => {
				setCardIdOptions(
					data.map((card) => {
						return {
							value: card._id,
							label: card.name,
						};
					})
				);
			},
		}
	);

	useEffect(() => {
		if (examType?.value && company?.value) {
			if (examType.value === "pyq" && cardId?.value) {
				developAxios(localStorage.getItem("token") || "")
					.get<{
						_id: string;
						mcq: Array<{
							_id: string;
							examName: string;
						}>;
						name: string;
						coding: Array<{
							_id: string;
							groupName: string;
						}>;
					}>("/ps/getCard/" + company?.value + "/" + cardId?.value)
					.then(({ data }) => {
						setExamOptions([
							...data.mcq.map((exam) => {
								return {
									value: exam._id,
									label: `mcq ${exam.examName}`,
								};
							}),
							...data.coding.map((exam) => {
								return {
									value: exam._id,
									label: `code ${exam.groupName}`,
								};
							}),
						]);
					})
					.catch((err: any) => console.log(err?.response));
			} else {
				developAxios(localStorage.getItem("token") || "")
					.get<{
						name: string;
						questions: Array<{
							_id: string;
							nameoftheExam: string;
						}>;
					}>("/ps/getMockQuestions/" + company?.value)
					.then(({ data }) => {
						setExamOptions(
							data.questions.map((exam) => {
								return {
									value: exam._id,
									label: exam.nameoftheExam,
								};
							})
						);
					})
					.catch((err) => console.log(err?.response));
			}
		}
	}, [examType?.value, company?.value, cardId?.value]);

	function downloadResults() {
		if (examType?.value === "pyq") {
			if (examId) {
				let type = examId.label.split(" ")[0];

				if (type === "mcq") {
					fetch(
						`${BASE_URL}/get-quiz-results/${examId?.value}/${course?.value}`
					)
						.then((res) => res.blob())
						.then((blob) => {
							const url = window.URL.createObjectURL(
								new Blob([blob])
							);
							const link = document.createElement("a");
							link.href = url;
							link.setAttribute("download", `${fileName}.xlsx`);
							document.body.appendChild(link);
							link.click();
							link.parentNode?.removeChild(link);
						})
						.catch((err) => {
							console.log(err);
							alert("Unable to download results");
						});
				} else {
					fetch(
						`${BASE_URL}/get-coding-bundle-results/${course?.value}/${cardId?.value}/${examId?.value}/${company?.value}`
					)
						.then((res) => res.blob())
						.then((blob) => {
							const url = window.URL.createObjectURL(
								new Blob([blob])
							);
							const link = document.createElement("a");
							link.href = url;
							link.setAttribute("download", `${fileName}.xlsx`);
							document.body.appendChild(link);
							link.click();
							link.parentNode?.removeChild(link);
						})
						.catch((err) => {
							console.log(err);
							alert("Unable to download results");
						});
				}
			}
		} else if (examType?.value === "mock") {
			if (course?.value && examId?.value) {
				fetch(
					`${BASE_URL}/get-hybrid-results/${examId?.value}/${course?.value}`
				)
					.then((res) => res.blob())
					.then((blob) => {
						const url = window.URL.createObjectURL(
							new Blob([blob])
						);
						const link = document.createElement("a");
						link.href = url;
						link.setAttribute("download", `${fileName}.xlsx`);
						document.body.appendChild(link);
						link.click();
						link.parentNode?.removeChild(link);
					})
					.catch((err) => {
						console.log(err);
						alert("Unable to download results");
					});
			}
		}
	}
	return (
		<div className="px-4 flex flex-column gap-3 mt-4">
			<div className="course-div flex items-center gap-2 w-full">
				<span className="w-40">
					<strong>Select Course:</strong>
				</span>
				<Select
					//@ts-ignore
					options={courseOptions}
					value={course}
					onChange={(e) => setCourse(e)}
					className="select grow"
				/>
			</div>

			<div className="company-div flex items-center gap-2 w-full">
				<span className="w-40">
					<strong>Select Company:</strong>
				</span>
				<Select
					//@ts-ignore
					options={companyOptions}
					value={company}
					onChange={(e) => setCompany(e)}
					className="select grow"
				/>
			</div>

			<div className="exam-type-div flex items-center gap-2 w-[50%]">
				<span className="w-40">
					<strong>Exam Type:</strong>
				</span>
				<Select
					//@ts-ignore
					options={[
						{
							value: "pyq",
							label: "Previous Year Questions (PYQ)",
						},
						{
							value: "mock",
							label: "Mock Test",
						},
					]}
					value={examType}
					onChange={(e) => setExamType(e)}
					className="select grow"
				/>
			</div>

			<div className="exam-data-div flex items-center gap-2 justify-between">
				<div className="exam-card-container flex items-center w-[40%]">
					<span className="w-32">
						<strong>Card Id:</strong>
					</span>
					<Select
						//@ts-ignore
						options={cardIdOptions}
						value={cardId}
						onChange={(e) => setCardId(e)}
						className="select grow"
					/>
				</div>

				<div className="exam-name-container flex items-center w-[40%]">
					<span className="w-32">
						<strong>Select Exam:</strong>
					</span>
					<Select
						//@ts-ignore
						options={examOptions}
						value={examId}
						onChange={(e) => setExamId(e)}
						className="select grow"
					/>
				</div>
			</div>

			<Form.Control
				type="text"
				placeholder="Enter File Name"
				value={fileName}
				onChange={(e) => setFileName(e.target.value)}
				className="w-[50%] mx-auto"
			/>

			<div className="submit-button-container flex justify-center">
				<button
					className="bg-green-500 text-white px-4 py-2 rounded-md font-semibold"
					onClick={downloadResults}
				>
					Get Results
				</button>
			</div>
		</div>
	);
};

export default GetResults;
